import gql from 'graphql-tag';

export const HouseSummaryResultsPartial = gql`
  subscription houseSummaryResultsPartial(
    $jobId: String!
    $assetUuid: String!
    $timeResolutionHrs: Int
  ) {
    simulationAreaResultsPartial(
      jobId: $jobId
      areaUUID: $assetUuid
      timeResolutionHrs: $timeResolutionHrs
    ) {
      currentMarket
      areaThroughput
      marketSummary {
        averageEnergyRate
        timestamp
      }
      status
    }
  }
`;
